import React, { useCallback } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'

type PaginationProps = {
	pageIndex: number,
	pageSize: number,
	totalCount: number,
	onPageIndexChange?: (ix: number) => void,
}

const Pagination: React.FC<PaginationProps> = (props) => {
	const { onPageIndexChange, pageIndex, pageSize, totalCount } = props

	const start = (pageIndex * pageSize) + 1
	let end = Math.min((pageIndex + 1) * pageSize, totalCount)

	const handlePrevClick = useCallback(
		() => {
			if (pageIndex <= 0) {
				return
			}

			if (onPageIndexChange) {
				onPageIndexChange(pageIndex - 1)
			}
		},
		[onPageIndexChange, pageIndex],
	)

	const handleNextClick = useCallback(
		() => {
			if ((pageIndex + 1) * pageSize > totalCount) {
				return
			}

			if (onPageIndexChange) {
				onPageIndexChange(pageIndex + 1)
			}
		},
		[onPageIndexChange, pageIndex, pageSize, totalCount],
	)

	return (
		<div className="flex text-sm items-center justify-between font-semibold text-gray-500">
			<FaChevronLeft onClick={handlePrevClick} className="cursor-pointer hover:text-red-600 mr-1" />
			{start} to {end}, of {totalCount}
			<FaChevronRight onClick={handleNextClick} className="cursor-pointer hover:text-red-600 ml-1" />
		</div>
	)
}

export default Pagination
